export default "__VITE_ASSET__DInilf98__"